import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

function NotFound() {
  const navigate = useNavigate();

  useEffect(() => {
    console.log("Rendered NotFound page");
  }, []);

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#ffffff'
      }}
      className="w-full"
    >
      <img
        src="https://skroop.org/images/skroop_transparent_thick.png"
        alt="Skroop Logo"
        style={{ width: '120px', height: 'auto' }}
        className="mb-6"
      />
      <h2 className="text-2xl font-semibold mb-4 text-center">
        This Skroop page does not exist
      </h2>
      <div className="flex flex-col items-center space-y-2">
        <p><Link to="/" className="text-indigo-600 hover:underline">
          Go back to the Homepage
        </Link>
        </p>
        <br />
        <p>
        <button
          onClick={() => navigate(-1)}
          className="text-indigo-600 hover:underline"
        >
          Go back to the previous page
        </button></p>
      </div>
    </div>
  );
}

export default NotFound;
